
export class SizeOverlap {
  readonly label?: string;

  private constructor(label?: string) {
    this.label = label;
  }

  static NONE = new SizeOverlap('None');
  static SOME = new SizeOverlap( 'Some');
  static ALL = new SizeOverlap('All');

  /**
   * Return the overlap between a set and its subset only looking at the size of the sets.
   * @param set
   * @param subset
   */
 static between<T>(set: T[], subset: T[]): SizeOverlap {
    if (set.length === subset.length) {
      return this.ALL;
    } else if (subset.length > 0) {
      return this.SOME;
    } else {
      return this.NONE;
    }
  }
}
